import { useState, useEffect } from "react";
import { KeyRound } from "lucide-react";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { toast } from "sonner";

export default function PerfilPadre() {
    const { user } = useAuth();
    const [child, setChild] = useState(null);
    const [form, setForm] = useState({ current_password: "", new_password: "", confirm_password: "" });
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        async function load() {
            if (!user.parent_of) return;
            const r = await api.get(`/student-profile/${user.parent_of}`);
            setChild(r.data);
        }
        load();
    }, [user.parent_of]);

    async function changePassword() {
        if (!form.current_password || !form.new_password || !form.confirm_password) {
            toast.error("Completá todos los campos");
            return;
        }
        if (form.new_password !== form.confirm_password) {
            toast.error("Las contraseñas nuevas no coinciden");
            return;
        }
        if (form.new_password.length < 6) {
            toast.error("La contraseña debe tener al menos 6 caracteres");
            return;
        }
        setSaving(true);
        try {
            await api.post("/auth/change-password", {
                current_password: form.current_password,
                new_password: form.new_password,
            });
            toast.success("Contraseña actualizada");
            setForm({ current_password: "", new_password: "", confirm_password: "" });
        } catch (e) {
            toast.error(e.response?.data?.detail || "Error al cambiar la contraseña");
        } finally {
            setSaving(false);
        }
    }

    return (
        <div className="p-6 md:p-10 fade-in">
            <h1 className="text-3xl font-semibold mb-1">Mi Perfil</h1>
            <p className="text-edu-body mb-8">Administrá tu información personal.</p>

            <div className="edu-card p-6 mb-6 max-w-md mx-auto">
                <h2 className="text-lg font-semibold mb-4">Mis datos</h2>
                <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                        <span className="text-edu-muted">Nombre</span>
                        <span className="font-medium">{user?.name}</span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-edu-muted">Email</span>
                        <span className="font-medium">{user?.email}</span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-edu-muted">Colegio</span>
                        <span className="font-medium">{user?.school || "—"}</span>
                    </div>
                </div>
            </div>

            <div className="edu-card p-6 mb-6 max-w-md mx-auto">
                <h2 className="text-lg font-semibold mb-4">Mi hijo/a</h2>
                {!user.parent_of ? (
                    <p className="text-sm text-edu-muted">No tenés un hijo/a asociado.</p>
                ) : !child ? (
                    <p className="text-sm text-edu-muted">Cargando…</p>
                ) : (
                    <div className="space-y-2 text-sm">
                        <div className="flex justify-between">
                            <span className="text-edu-muted">Nombre</span>
                            <span className="font-medium">{child.name}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-edu-muted">Grado</span>
                            <span className="font-medium">{child.grade || "—"}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-edu-muted">Colegio</span>
                            <span className="font-medium">{child.school || "—"}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-edu-muted">Monedas</span>
                            <span className="font-medium">
                                {child.coin_balance ?? 0}{" "}
                                <span style={{ color: "#F5A623", fontWeight: "bold" }}>●</span>
                            </span>
                        </div>
                    </div>
                )}
            </div>

            <div className="edu-card p-6 max-w-md mx-auto">
                <h2 className="text-lg font-semibold mb-4 inline-flex items-center gap-2">
                    <KeyRound size={18} /> Cambiar contraseña
                </h2>
                <div className="space-y-3">
                    <label className="block">
                        <span className="text-xs uppercase tracking-widest text-edu-muted font-semibold mb-1.5 block">
                            Contraseña actual
                        </span>
                        <input
                            type="password"
                            value={form.current_password}
                            onChange={(e) => setForm({ ...form, current_password: e.target.value })}
                            className="edu-input w-full"
                        />
                    </label>
                    <label className="block">
                        <span className="text-xs uppercase tracking-widest text-edu-muted font-semibold mb-1.5 block">
                            Nueva contraseña
                        </span>
                        <input
                            type="password"
                            value={form.new_password}
                            onChange={(e) => setForm({ ...form, new_password: e.target.value })}
                            className="edu-input w-full"
                        />
                    </label>
                    <label className="block">
                        <span className="text-xs uppercase tracking-widest text-edu-muted font-semibold mb-1.5 block">
                            Confirmar nueva contraseña
                        </span>
                        <input
                            type="password"
                            value={form.confirm_password}
                            onChange={(e) => setForm({ ...form, confirm_password: e.target.value })}
                            className="edu-input w-full"
                        />
                    </label>
                    <button
                        onClick={changePassword}
                        disabled={saving}
                        className="edu-btn-primary px-4 py-2 text-sm w-full mt-2"
                    >
                        {saving ? "Guardando…" : "Cambiar contraseña"}
                    </button>
                </div>
            </div>
        </div>
    );
}
